import React, { FC } from "react";
import { Path, Svg, SvgProps } from "react-native-svg";

const MH: FC<SvgProps> = (props) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M9.88514 22.7151C10.0057 21.1936 10.1396 18.3909 9.95401 18.024C9.38595 16.9009 7.19197 17.8932 6.25294 17.4624C5.58163 17.1545 5.93998 15.8121 5.93998 15.6276C5.93998 15.4431 5.4765 14.9155 5.44388 14.7273C5.40736 14.5174 5.70314 14.3336 5.35003 14.1683C5.15119 14.0752 5.54149 13.3802 5.38212 13.1286C5.22261 12.877 4.17 12.6213 4.17 12.1372C4.17 11.7206 5.01048 10.7361 5.35782 10.2354C5.82263 9.56537 5.89231 9.13421 5.8476 7.53279C5.77094 4.78356 7.40625 2.0486 11.168 1.24421C16.5483 0.0934364 18.5444 2.75141 19.3012 4.65698C19.9994 6.41507 20.0421 9.09438 19.2134 10.5475C17.8842 12.8784 16.754 13.4699 16.7686 14.9261C16.7859 16.6555 17.3045 19.5816 17.7348 22.7151H15.7724L12.725 11.9851"
        stroke={props.color || "#71706F"}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <Path
        d="M12.7249 11.9851L9.01818 8.43516L8.41763 7.86005C7.39418 6.87948 7.39418 5.29022 8.41763 4.31013C9.44107 3.33005 11.1007 3.33005 12.1246 4.31013L12.7252 4.88524L13.3257 4.31013C14.3497 3.33005 16.0093 3.33005 17.0327 4.31013C18.0562 5.29046 18.0559 6.87972 17.0325 7.86005L16.4319 8.43516L14.5784 10.2101"
        stroke={props.color || "#71706F"}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default MH;
